import React, { useState, useEffect, useMemo } from "react";
import Axios from "axios";
import { Container } from "react-bootstrap";
import { Card, Col, Row, Avatar, Spin, Button } from "antd";
import { RiSendPlaneLine } from "react-icons/ri";
const { Meta } = Card;

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const memoizedValue = useMemo(async () => {
    await Axios.get("https://api.github.com/users/Manitej66/repos").then(
      res => {
        setLoading(false);
        setProjects(res.data);
        console.log(res.data);
      }
    );
  }, []);

  if (loading) {
    return (
      <div
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20%",
          flexDirection: "column"
        }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Container>
      <h3
        style={{
          fontWeight: "bold",
          fontFamily: "Ubuntu Mono",
          color: "white",
          marginTop: 10
        }}>
        My Projects
      </h3>
      <div className="site-card-wrapper">
        <Row gutter={32}>
          {projects.map((project, index) => (
            <Col key={index} xs={24} sm={12} md={8} lg={8} xl={8}>
              <Card
                bordered={false}
                loading={loading}
                onClick={() => window.open(project.html_url)}
                style={{
                  width: "90%",
                  margin: 16,
                  marginLeft: "auto",
                  marginRight: "auto",
                  background: "linear-gradient(145deg, #06174a, #071c58)",
                  borderWidth: 0,
                  borderRadius: 0,
                  boxShadow: "7px 7px 14px #061542, -7px -7px 14px #081f62"
                }}
                className="card"
                loading={loading}>
                <Meta
                  avatar={<Avatar src={project.owner.avatar_url} />}
                  title={
                    <span
                      style={{
                        color: "yellow",
                        fontFamily: "Ubuntu Mono",
                        fontWeight: "bold",
                        textShadow: "1px 1px 18px white"
                      }}>
                      {project.name}
                    </span>
                  }
                  description={
                    <span
                      style={{
                        color: "white",
                        fontFamily: "Ubuntu Mono",
                        opacity: 0.7
                      }}>
                      {project.language}
                    </span>
                  }
                />
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </Container>
  );
};

export default Projects;
